// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"524":"be5ffd0c","900":"83c3ccaa"}[chunkId] + ".js";
};